import { get } from 'lodash'
import { required, requiredPhone, email, phone, checkAwardLeaderMinAge, maxLength } from 'utils/validation'
import { CONFIGURATION_KEYS } from '../../../../constants/enums'

const validate = (values, props) => {
  let errors = {}

  errors = {
    firstName: required(get(values, 'firstName')),
    lastName: required(get(values, 'lastName')),
    role: required(get(values, 'role')),
    email: required(get(values, 'email')) || email(get(values, 'email')),
    phoneNumber: requiredPhone(get(values, 'phoneNumber')) ||
      phone(get(values, 'phoneNumber')),
    phoneType: {
      value: required(get(values, 'phoneType.value'))
    },
    emailAgain: required(get(values, 'emailAgain'))
  }

  if (get(values, 'email') && get(values, 'emailAgain')) {
    if (get(values, 'email') !== get(values, 'emailAgain')) {
      errors = {
        ...errors,
        emailAgain: {
          text: "Emails don't match",
          intlKey: 'errors.emails_dont_match'
        }
      }
    }
  }

  if (get(values, 'licenseHolderAsCoordinator')) {
    const minAgeCfg = get(props, `configuration.values[${CONFIGURATION_KEYS.leaderMinAge.id}]`)

    const minAge = get(minAgeCfg, 'intValue')

    errors = {
      ...errors,
      awardLeaderRegistration: {
        gender: {
          value: required(get(values, 'awardLeaderRegistration.gender.value'))
        },
        line1: required(get(values, 'awardLeaderRegistration.line1')),
        zipCode: required(get(values, 'awardLeaderRegistration.zipCode')),
        stateOrProvinceOrRegion:
          required(get(values, 'awardLeaderRegistration.stateOrProvinceOrRegion')) ||
          maxLength(70)(get(values, 'awardLeaderRegistration.stateOrProvinceOrRegion')),
        city: required(get(values, 'awardLeaderRegistration.city')),
        addressCountryId: required(get(values, 'awardLeaderRegistration.addressCountryId')),
        email: required(get(values, 'awardLeaderRegistration.email')) || email(get(values, 'awardLeaderRegistration.email')),
        phoneNumber: requiredPhone(get(values, 'awardLeaderRegistration.phoneNumber')) ||
          phone(get(values, 'awardLeaderRegistration.phoneNumber')),
        phoneType: {
          value: required(get(values, 'awardLeaderRegistration.phoneType.value'))
        },
        emailAgain: required(get(values, 'awardLeaderRegistration.emailAgain')),
        minAgeConfirmation: required(get(values, 'awardLeaderRegistration.minAgeConfirmation'))
      }
    }
  }

  return errors
}

export default validate
